module.exports = __webpack_public_path__ + "static/media/render.b55eba2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/render.png
// module id = 88
// module chunks = 0